import MemberMetrics from './MemberMetrics'
import ScoreBadge from './ScoreBadge'

const MemberCard = ({
  member,
  regionName,
  supplierName,
  selectedMetric,
  onSelectMetric,
  // isExpanded,
  // onToggle
}) => {
  return (
    <div
      // className={`card bg-light border-0 mb-2 member-card ${isExpanded ? 'expanded' : ''}`}
      className={`card bg-light border-0 mb-2 member-card`}
    >
      <div className="card-body p-3">
        <div
          className="cursor-pointer mb-2"
          // onClick={onToggle}
          // style={{ cursor: 'pointer' }}
        >
          {/* MEMBER - DESKTOP VIEW */}
          <div className="d-none d-lg-flex align-items-center">
            {/* {isExpanded ? (
              <ChevronDown size={14} className="me-2 text-muted" />
            ) : (
              <ChevronRight size={14} className="me-2 text-muted" />
            )} */}
            <div className="me-4 flex-grow-1">
              <h6 className="mb-0">{member.name}</h6>
            </div>
            <div className="d-flex align-items-center gap-3 flex-shrink-0">
              <div
                className="d-flex align-items-center gap-2 p-1 rounded"
                style={{ cursor: onSelectMetric ? 'pointer' : 'default' }}
                onClick={(e) => {
                  e.stopPropagation()
                  if (onSelectMetric) {
                    onSelectMetric({
                      metricKey: 'contract',
                      metricLabel: 'Contract',
                      value: member.detailData?.percentages?.contract ?? member.onboarding?.contract,
                      category: 'onboarding',
                      regionName: regionName || 'Homeweavers',
                      supplierName: supplierName || '-',
                      entityName: member.name,
                      entityId: member.id || member.name,
                      entityType: 'Member',
                      entity: member,
                    })
                  }
                }}
                title="Klik untuk melihat rincian Onboarding"
              >
                <span className="small text-muted">Onboarding</span>
                <ScoreBadge
                  score={member?.onboardingScore}
                  size="normal"
                />
              </div>
              <div
                className="d-flex align-items-center gap-2 p-1 rounded"
                style={{ cursor: onSelectMetric ? 'pointer' : 'default' }}
                onClick={(e) => {
                  e.stopPropagation()
                  if (onSelectMetric) {
                    onSelectMetric({
                      metricKey: 'wageAboveMinimum',
                      metricLabel: 'Minimum Wage',
                      value:
                        member.detailData?.percentages?.wageAboveMinimum ??
                        member.wage?.wageAboveMinimum,
                      category: 'wage',
                      regionName: regionName || 'Homeweavers',
                      supplierName: supplierName || '-',
                      entityName: member.name,
                      entityId: member.id || member.name,
                      entityType: 'Member',
                      entity: member,
                    })
                  }
                }}
                title="Klik untuk melihat rincian Wage & Productivity"
              >
                <span className="small text-muted">Wage &amp; Productivity</span>
                <ScoreBadge score={member?.wageScore} size="normal" />
              </div>
            </div>
          </div>

          {/* MEMBER - MOBILE */}
          <div className="d-lg-none">
            <div className="d-flex align-items-center mb-3">
              {/* {isExpanded ? (
                <ChevronDown size={14} className="me-2 text-muted" />
              ) : (
                <ChevronRight size={14} className="me-2 text-muted" />
              )} */}
              <div className="flex-grow-1">
                <h6 className="mb-0">{member.name}</h6>
              </div>
            </div>

            {/* MEMBER - SCORES FOR MOBILE VIEW */}
            <div className="row g-2">
              <div className="col-6">
                <div
                  className="d-flex align-items-center justify-content-center p-2 rounded cursor-pointer"
                  style={{
                    backgroundColor: '#f0fbff',
                    border: '1px solid #e5e7eb',
                    cursor: onSelectMetric ? 'pointer' : 'default',
                  }}
                  onClick={(e) => {
                    e.stopPropagation()
                    if (onSelectMetric) {
                      onSelectMetric({
                        metricKey: 'contract',
                        metricLabel: 'Contract',
                        value: member.detailData?.percentages?.contract ?? member.onboarding?.contract,
                        category: 'onboarding',
                        regionName: regionName || 'Homeweavers',
                        supplierName: supplierName || '-',
                        entityName: member.name,
                        entityId: member.id || member.name,
                        entityType: 'Member',
                        entity: member,
                      })
                    }
                  }}
                >
                  <div className="text-center">
                    <div className="small text-muted mb-1">Onboarding</div>
                    <ScoreBadge
                      score={member?.onboardingScore}
                      size="normal"
                    />
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div
                  className="d-flex align-items-center justify-content-center p-2 rounded cursor-pointer"
                  style={{
                    backgroundColor: '#f0fbff',
                    border: '1px solid #e5e7eb',
                    cursor: onSelectMetric ? 'pointer' : 'default',
                  }}
                  onClick={(e) => {
                    e.stopPropagation()
                    if (onSelectMetric) {
                      onSelectMetric({
                        metricKey: 'workHours',
                        metricLabel: 'Work Hours',
                        value: member.detailData?.percentages?.workHours ?? member.wage?.workHours,
                        category: 'wage',
                        regionName: regionName || 'Homeweavers',
                        supplierName: supplierName || '-',
                        entityName: member.name,
                        entityId: member.id || member.name,
                        entityType: 'Member',
                        entity: member,
                      })
                    }
                  }}
                >
                  <div className="text-center">
                    <div className="small text-muted mb-1">W&amp;P</div>
                    <ScoreBadge score={member?.wageScore} size="normal" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* MEMBER METRICS */}
        {/* <div
          className={`collapsible-content ${isExpanded ? 'collapsible-enter-active' : 'collapsible-enter'}`}
          style={{
            maxHeight: isExpanded ? 'none' : '0',
            opacity: isExpanded ? 1 : 0,
            transform: isExpanded ? 'translateY(0)' : 'translateY(-10px)',
            overflow: isExpanded ? 'visible' : 'hidden',
            transition: isExpanded
              ? 'opacity 0.3s ease-out, transform 0.3s ease-out'
              : 'opacity 0.3s ease-in, transform 0.3s ease-in, max-height 0.3s ease-in',
          }}
        >
          {isExpanded && <MemberMetrics member={member} />}
        </div> */}
        <MemberMetrics
          member={member}
          regionName={regionName}
          supplierName={supplierName}
          selectedMetric={selectedMetric}
          onSelectMetric={onSelectMetric}
        />
      </div>
    </div>
  )
}

export default MemberCard
